export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_04.dcf26756.jpg";